import React from 'react'
import styled from 'styled-components'
import Brightness from '../scripts/Brightness'


const FeaturedCourses = (props) => {

  let bgStyle

  if (props.img !== undefined) {
    bgStyle = {
      backgroundImage: 'url(https://assets.lmscourses.com/slide-images/' +  props.img + ')'
    }
  }

  const HoverDarker = Brightness(props.homeOverlay, -0.6)

  const FeatureOverlay = styled.div`
    &:before {
      background: linear-gradient(20deg, ${props.homeOverlay} 30%, rgba(0,0,0,0.0) 80%);
    }

    .infoBlock {
      a {
        color: white;
        background-color: black;

        &:hover {
          background-color: ${HoverDarker};
        }
      }
    }
  `

  return (
    <div className="featureContainer">
      <FeatureOverlay className="feature" style={bgStyle}>
        <div className="infoBlock">
          <h1>{props.title}</h1>
          <p>{props.desc}</p>
          <a target="_blank" href={'https://' + props.localURL + '/index.php?/en-us/' + props.url + '/P1'}>Preview</a>
        </div>
      </FeatureOverlay>
    </div>
  )

}

export default FeaturedCourses
